<div>
    <h1 id="title" class="title color-brand">{{ "AUTH.RECOVER-ACCOUNT" | translate }}</h1>
    <p class="paragraph text-hint">
        {{ "RECOVER-ACCOUNT.DESCRIPTION" | translate }}
    </p>
    <form [formGroup]="formRecover" (ngSubmit)="onRecover()">
        <div class="form-control-group">
            <label for="fullName">{{ "USER.NAME" | translate }}</label>
            <input nbInput fullWidth id="fullName" formControlName="fullName" />
            <ng-container *ngIf="controls.fullName.invalid && controls.fullName.touched">
                <p class="error-message">{{ "MESSAGE.FIELD.MANDATORY-INPUT" | translate }}</p>
            </ng-container>
        </div>

        <div class="form-control-group">
            <label for="dateOfBirth">Data de nascimento</label>
            <input nbInput fullWidth [nbDatepicker]="picker" id="dateOfBirth" formControlName="dateOfBirth" />
            <nb-datepicker #picker></nb-datepicker>
            <ng-container *ngIf="controls.dateOfBirth.invalid && controls.dateOfBirth.touched">
                <p class="error-message">{{ "MESSAGE.FIELD.MANDATORY-INPUT" | translate }}</p>
            </ng-container>
        </div>

        <div class="form-control-group">
            <label for="email">{{ "USER.EMAIL" | translate }}</label>
            <input nbInput fullWidth id="email" type="email" formControlName="email" />
            <ng-container *ngIf="controls.email.invalid && controls.email.touched">
                <p class="error-message">{{ "MESSAGE.FIELD.VALID-MAIL" | translate }}</p>
            </ng-container>
        </div>

        <div class="form-control-group">
            <label for="cpf">{{ "USER.DOCUMENT" | translate }}</label>
            <input nbInput fullWidth id="cpf" formControlName="cpf" />
            <ng-container *ngIf="controls.cpf.invalid && controls.cpf.touched">
                <p class="error-message">{{ "MESSAGE.FIELD.MANDATORY-INPUT" | translate }}</p>
            </ng-container>
        </div>

        <div class="form-control-group">
            <label for="phone">{{ "CONTACT-PAGE.PHONE" | translate }}</label>
            <input
                nbInput
                fullWidth
                id="phone"
                formControlName="phone"
                [mask]="localStorage.isBrazil() ? '(00) 00000-0000' : null"
            />
            <ng-container *ngIf="controls.phone.invalid && controls.phone.touched">
                <p class="error-message">{{ "MESSAGE.FIELD.MANDATORY-INPUT" | translate }}</p>
            </ng-container>
        </div>

        <div class="form-control-group">
            <label for="country_id">{{ "USER.COUNTRY" | translate }}</label>
            <nb-select
                id="country_id"
                placeholder="{{ 'USER.COUNTRY' | translate }}"
                formControlName="country_id"
                fullWidth
                (selectedChange)="onLocaleChange('country', $event)"
            >
                <nb-option *ngFor="let country of locale?.countries" [value]="country.id_pais">{{
                    country.descricao
                }}</nb-option>
            </nb-select>
            <ng-container *ngIf="controls.country_id.invalid && controls.country_id.touched">
                <p class="error-message">{{ "MESSAGE.FIELD.MANDATORY" | translate }}</p>
            </ng-container>
        </div>

        <div class="form-control-group">
            <label for="state_id">{{ "USER.STATE" | translate }}</label>
            <nb-select
                id="state_id"
                placeholder="{{ 'USER.STATE' | translate }}"
                formControlName="state_id"
                fullWidth
                (selectedChange)="onLocaleChange('state', $event)"
            >
                <nb-option *ngFor="let state of locale?.states" [value]="state.id_uf">{{ state.descricao }}</nb-option>
            </nb-select>
            <ng-container *ngIf="controls.state_id.invalid && controls.state_id.touched">
                <p class="error-message">{{ "MESSAGE.FIELD.MANDATORY" | translate }}</p>
            </ng-container>
        </div>

        <div class="form-control-group">
            <label for="city_id">{{ "USER.CITY" | translate }}</label>
            <nb-select id="city_id" placeholder="{{ 'USER.CITY' | translate }}" formControlName="city_id" fullWidth>
                <nb-option *ngFor="let city of locale?.cities" [value]="city.id_cidade">{{ city.descricao }}</nb-option>
            </nb-select>
            <ng-container *ngIf="controls.city_id.invalid && controls.city_id.touched">
                <p class="error-message">{{ "MESSAGE.FIELD.MANDATORY" | translate }}</p>
            </ng-container>
        </div>

        <div class="form-control-group">
            <p class="text-hint mb-3">
                Os dados solicitados são necessários para comprovar sua identidade e garantir a segurança da recuperação
                da sua conta. Todas as informações fornecidas serão utilizadas exclusivamente para fins de recuperação
                de conta e não serão compartilhadas com terceiros.
            </p>
            <nb-checkbox formControlName="acceptDataUsage">
                Concordo com o uso dos meus dados pessoais exclusivamente para fins de recuperação de conta
            </nb-checkbox>
        </div>

        <button nbButton status="primary" fullWidth type="submit" [disabled]="formRecover.invalid || isSubmitting">
            <nb-spinner *ngIf="isSubmitting" size="small" status="basic"></nb-spinner>
            <span *ngIf="!isSubmitting">{{ "AUTH.RECOVER-ACCOUNT" | translate }}</span>
            <span *ngIf="isSubmitting">Enviando...</span>
        </button>
    </form>
</div>
